import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Col, Button, Modal, Alert, Spinner } from 'react-bootstrap';
import TaskTable from '../TaskTable';
import { useMsal } from "@azure/msal-react";
import { useGetTask } from '../../hooks/useTasks';
import { useCheckoutJob } from '../../hooks/useJobs';
import { SiteContext } from '../Contexts/SiteContext';

function CheckedOutJobDialogContent({ job, nextPage, updateJob, closeDialog }) {

    CheckedOutJobDialogContent.propTypes = {
        job: PropTypes.object,
        nextPage: PropTypes.func,
        updateJob: PropTypes.func,
        closeDialog: PropTypes.func
    }

    const { selectedSite } = useContext(SiteContext);
    const { task, loading } = useGetTask(selectedSite, job.taskName);
    const { checkoutJob, undoCheckoutJob, loading: loadingCheckoutJob } = useCheckoutJob();

    const { accounts } = useMsal();
    const username = accounts[0].username;

    const undoCheckoutJobAndClose = async () => {
        job = await undoCheckoutJob(job)
        updateJob(job);
        closeDialog();

        // add error handling for task and undo checkout
    }

    const reassignJob = async () => {
        job = await checkoutJob(job)
        updateJob(job);
    }

    if (loading || loadingCheckoutJob) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    const jobCheckedOutByOtherUser = username !== job.assignedUser;

    return (
        <>
            <Modal.Body>
                {job.action !== null &&
                    <p>Required Action: <b>{job.action}</b></p>
                }
                <div className="mb-4">
                    <TaskTable task={task} />
                </div>
                <p>Checked out by {job.assignedUser}</p>
                {jobCheckedOutByOtherUser &&
                    <Alert variant="danger" className="mt-2">You cannot work on a job checked out to another user</Alert>
                }
            </Modal.Body>
            <Modal.Footer>
                <Col>
                    <Button variant="warning" style={{ color: 'white' }} onClick={undoCheckoutJobAndClose} className="me-1">Undo Checkout</Button>
                    {jobCheckedOutByOtherUser &&
                        <Button variant="primary" onClick={reassignJob}>Reassign Job</Button>
                    }
                </Col>
                <Col>
                    <Button variant="primary" onClick={nextPage} disabled={username !== job.assignedUser} className="float-end">Next</Button>
                </Col>
            </Modal.Footer>
        </>
    );
}

export default CheckedOutJobDialogContent;